import { MailOutlined } from "@ant-design/icons";

import { Button, Layout, notification, Space, theme, Typography } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Tabs } from "antd";
import "./prestations.css";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import routes from "../../../engine/routes";
import { getPrestations } from "../Slices/Prestations.slice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  ActionRoleSpecific,
  onlyRoleMapping,
  UserCanDoActionMemo,
  userHasLevel,
} from "../../../engine/AuthRoute";
import {
  daysJsFormat,
  renderStatusPrestation,
  renderStatusTag,
  renderUserName,
  roles,
  statusPrestations,
  statusPrestationsValues,
  subRoles,
  subStatus,
  subStatusPrestations,
} from "../../../utils/constants";
import { TbSquareArrowDown } from "react-icons/tb";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import dayjs from "../../../utils/dayjs";
import { clearPrestation } from "../Slices/Prestation.slice";
import {
  columnsPrestationsList,
  defaultSorterByTab,
  inputsPrestationsList,
} from "./Prestations.list.constants";
import { setPagination } from "../../Billing/Slices/Billing.slice";
import { BiSearch } from "react-icons/bi";
import {
  confirmDraftDeleteByBatch,
  newPrestationSelectors,
} from "../../../shared/components/Modals/modals";
import { IoMdDownload } from "react-icons/io";
import { BillsExportsExcel } from "../../Billing/BillingList/BillsExportsExcel";
import _ from "lodash";
import { UserContext } from "../../../engine/context/User.context";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { http } from "../../../engine/api/http";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationsList(props) {
  const {
    prestations,
    loading,
    interpretes,
    institutionsFilter,
    totals,
  } = useSelector(state => state.prestations);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const { user } = useContext(UserContext);

  const formRef = useRef(null);

  const now = dayjs();
  let monthNexts = 1;
  if (onlyRoleMapping([roles.institution, roles.interprete])) {
    monthNexts = 12;
  }

  // const monthsAfter = now.add(monthNexts, "month");
  //
  // const threeMonthsBefore = now.subtract(1, "month");

  const defaultRanges = [undefined, undefined];
  const searcher = localStorage.getItem("prestationsSearcher");

  const searcherObj = JSON.parse(searcher);

  const [advancedSearch, setAdvancedSearch] = React.useState(
    searcherObj?.advancedSearch || false,
  );

  const [tab, setTab] = React.useState(searcherObj?.tab || "schedules");

  const [searchState, setSearchState] = React.useState(
    searcherObj?.searchState || {},
  );

  const defaultPagination = {
    totalPages: 0,
    currentPage: 1,
    pageSize: 100,
    sorter: defaultSorterByTab(tab),
  };

  const [pagination, setPagination] = React.useState(
    searcherObj?.pagination || defaultPagination,
  );

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onChangeTab = (tab, p, r) => {
    setPagination({
      ...defaultPagination,
      sorter: defaultSorterByTab(tab),
      pageSize: pagination.pageSize,
    });
    setTab(tab);
  };

  // Keep the latest filter reachable from the async cleanup below.
  const searchStateRef = useRef(searchState);
  searchStateRef.current = searchState;

  // A saved filter can name an institution that has since been merged away
  // (archived) or deleted: drop it once the live institutions are known, so the
  // list is not silently empty. Never touch the filter if the fetch fails.
  // Institution users only get their own institution from /institutions.
  const isInstitutionUser = onlyRoleMapping([roles.institution]);

  useEffect(() => {
    const saved = searcherObj?.searchState?.institution;
    const hasSaved = Array.isArray(saved) ? saved.length > 0 : !!saved;
    if (!hasSaved || isInstitutionUser) {
      return;
    }

    let cancelled = false;

    http
      .get("institutions")
      .then(res => {
        if (cancelled || !Array.isArray(res?.data)) {
          return;
        }

        const liveIds = new Set(res.data.map(i => String(i._id)));
        const current = searchStateRef.current?.institution;

        let next = current;
        if (Array.isArray(current)) {
          next = current.filter(id => liveIds.has(String(id)));
          if (next.length === current.length) {
            return;
          }
        } else if (!current || liveIds.has(String(current))) {
          return;
        } else {
          next = undefined;
        }

        const cleaned = { ...searchStateRef.current, institution: next };
        if (next === undefined) {
          delete cleaned.institution;
        }

        formRef.current?.setFieldsValue({ institution: next });
        // Persist right away: the form reads its values from localStorage.
        const stored = JSON.parse(
          localStorage.getItem("prestationsSearcher") || "{}",
        );
        localStorage.setItem(
          "prestationsSearcher",
          JSON.stringify({ ...stored, searchState: cleaned }),
        );
        setSearchState(cleaned); // re-runs the search and persists again

        notification.info({
          message: "Filtre mis à jour : établissement fusionné retiré",
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  // useEffect(() => {
  //   // setPagination({ ...pagination, sorter: defaultSorterByTab(tab) });
  // }, [tab]);

  useEffect(() => {
    dispatchActionPrestations(searchState);

    const searcher = {
      tab,
      searchState,
      pagination,
      advancedSearch,
    };

    localStorage.setItem("prestationsSearcher", JSON.stringify(searcher));
  }, [tab, searchState, pagination]);

  const dispatchActionPrestations = () => {
    const search = objectToUrlParams({
      ...searchState,
      tab,
      ...pagination,
    });
    setSelectedRowKeys([]);

    dispatch(getPrestations({ search }));
  };

  const handleKeyUp = async event => {
    // Enter
    if (event.keyCode === 13) {
      formRef.current.submit();
    }

    // if (event.code === "Backspace" || event.code === "Delete") {
    //   setSearchState({});
    //
    //   formRef.current.resetFields(); // Reset the form fields using the ref
    //   // formRef.current.setFieldsValue(initialValuesForm);
    //   setPagination(defaultPagination);
    //   await dispatchActionPrestations();
    // }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  const onValuesChange = (changedValues, allValues) => {
    // Object.keys(changedValues).map(changed => {
    //   switch (changed) {
    //     case "reference":
    //       if (
    //         changedValues[changed].length > 3 ||
    //         changedValues[changed].length === 0
    //       ) {
    //         setSearchState(allValues);
    //       }
    //
    //       break;
    //     default:
    //       setSearchState(allValues);
    //       break;
    //   }
    // });
  };

  const handleSubmit = data => {
    if (
      data?.rangeDate === undefined ||
      data?.rangeDate === null ||
      data?.rangeDate === undefined ||
      data?.rangeDate[0] === undefined ||
      data?.rangeDate[1] === undefined
    ) {
      delete data.rangeDate;
    }

    if (data.reference === null) {
      delete data.reference;
    }
    setSearchState(data);
  };

  const newPrestationLink = async () => {
    newPrestationSelectors({
      onOk: async () => {},
      content: {
        navigate,
      },
    });

    await dispatch(clearPrestation());
    // navigate(routes.prestations("new").detail.path);
  };

  const smTitle = item => {
    return (
      <div className={"alignHeaderPage"}>
        {renderStatusPrestation(item, {
          showControls: userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
        })}
        <Typography ellipsis={true} level={3}>
          {item?.institution?.name === undefined
            ? item?.reference
            : item?.institution?.name}
        </Typography>
      </div>
    );
  };

  const isAdmin = userHasLevel({
    only: {
      [roles.admin]: "crud", //
      [roles.permanance]: "crud", //
    },
  });

  const onSelectChange = r => {
    setSelectedRowKeys(r);
  };

  const renderTableSorted = (sortedData, key) => {
    const getCheckboxProps = record => {
      const disabledCode = ["9100"];

      const isDisabled = record.status !== statusPrestationsValues.draft;

      return {
        disabled: isDisabled,
      };
    };

    return (
      <CustomTable
        onSelectChange={onSelectChange}
        getCheckboxProps={getCheckboxProps}
        key={key}
        loading={loading}
        smTitle={smTitle}
        hasSelection={searchState?.advancedCols}
        onRowLink={record => routes.prestations(record._id).detail.path}
        dataSource={sortedData}
        columns={columnsPrestationsList(sortedData, searchState)}
        rowKey="_id"
        pagination={{
          hideOnSinglePage: false,
          position: ["topRight"],
          defaultPageSize: pagination.pageSize,
          pageSizeOptions: [
            ...[10, 20, 50, 100, 250],
            ...(advancedSearch && searchState?.advancedCols ? [500, 1000] : []),
          ],
          showSizeChanger: true,
          current: pagination.currentPage,
          total: totals[key],
          showTotal: (total, range) => (
            <span>
              {advancedSearch && searchState?.advancedCols && isAdmin ? (
                <Button
                  size={"small"}
                  type={"primary"}
                  style={{ marginRight: 10 }}
                  onClick={async () => {
                    let clone = _.cloneDeep(prestations).map(e => {
                      if (e.bill !== null) {
                        return {
                          ...e,
                          bill: {
                            ...e.bill,
                            institution: e.institution,
                          },
                        };
                      } else {
                        return e;
                      }
                    });
                    BillsExportsExcel(clone, false);
                  }}
                >
                  <Space>
                    <IoMdDownload />
                    Exporter les prestations
                  </Space>
                </Button>
              ) : null}
              {advancedSearch && searchState?.advancedCols && isAdmin ? (
                <Button
                  size={"small"}
                  disabled={selectedRowKeys.length === 0}
                  type={"primary"}
                  style={{ marginRight: 10 }}
                  onClick={async () => {
                    confirmDraftDeleteByBatch({
                      onOk: async () => {
                        try {
                          let deleter = await http.post(
                            "/prestations/delete_drafts",
                            {
                              prestations: selectedRowKeys,
                            },
                          );
                          notification.success({
                            message: `${selectedRowKeys.length} prestation${
                              selectedRowKeys.length > 1 ? "s" : ""
                            } ont été supprimée${
                              selectedRowKeys.length > 1 ? "s" : ""
                            }`,
                          });
                          dispatchActionPrestations();
                        } catch (e) {
                          notification.error({
                            message: "Une erreur est survenue",
                          });
                        }
                      },
                      array: selectedRowKeys,
                    });
                  }}
                >
                  <Space>
                    <RiDeleteBin2Fill />
                    Supprimer les brouillons
                  </Space>
                </Button>
              ) : null}
              {`${range[0]}-${range[1]} sur ${total} prestations`}
            </span>
          ),
        }}
        onChange={async (p, filters, sorter, extra) => {
          let extraSorter = {};

          if (sorter.order !== undefined) {
            extraSorter = {
              sorter: {
                key: sorter.columnKey,
                order: sorter.order,
              },
            };
          } else {
            extraSorter = {
              sorter: defaultPagination.sorter,
            };
          }

          setPagination({
            currentPage: p.current,
            pageSize: p.pageSize,
            ...extraSorter,
          });
        }}
      />
    );
  };

  const renderAVenir = () => {
    const key = "schedules";

    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Prévues (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };
  const renderAVenir24h = () => {
    const key = "min72h";

    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Moins de 72h  (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderToday = () => {
    const now = dayjs(); // Current date and time
    const startOfDay = now.startOf("day"); // Start of the current day (00:00)
    const endOfDay = now.endOf("day"); // End of the current day (23:59)

    const todayPrestations = prestations.filter(item => {
      const startDate = dayjs(item.finalStartDate);
      return startDate.isAfter(startOfDay) && startDate.isBefore(endOfDay);
    });

    const sorted = todayPrestations.sort((a, b) =>
      dayjs(a.finalStartDate).isBefore(dayjs(b.finalStartDate)) ? -1 : 1,
    );
    const key = "today";

    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Aujourd'hui (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderAFinalise = () => {
    const sorted = prestations.filter(prestation => {
      return [
        statusPrestationsValues.draft,
        statusPrestationsValues.waiting,
      ].includes(prestation.status);
    });
    const key = "draft";

    return onlyRoleMapping([
      roles.admin,
      roles.permanance,
      roles.institution,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`Brouillons (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };

  const renderWaiting = () => {
    const key = "waiting";

    return onlyRoleMapping([
      roles.admin,
      roles.permanance,
      roles.institution,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`${"En attente de réponse"} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };

  const renderAccepter = () => {
    const key = "toConfirm";

    return onlyRoleMapping([
      roles.interprete,
      roles.institution,
      subRoles.institutionDemander,
      subRoles.institutionAdmin,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`A accepter (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };

  const renderTerminee = () => {
    const sorted = prestations.filter(prestation => {
      return [
        statusPrestationsValues.finish,
        statusPrestationsValues.finish_permanance,
        statusPrestationsValues.finish_notsigned,
      ].includes(prestation.status);
    });
    const key = "done";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Terminées (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderRetard = () => {
    const now = dayjs(); // Obtenez la date et l'heure actuelles

    const enRetard = prestations.filter(item => {
      const endDate = dayjs(item.finalEndDate);
      return (
        endDate.isBefore(now) && item.status === statusPrestationsValues.planned
      );
    });

    const sorted = enRetard.sort((a, b) =>
      dayjs(a.finalEndDate).isBefore(dayjs(b.finalEndDate)) ? -1 : 1,
    );
    const key = "nonClosed";

    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Non clôturées (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderAnnule = () => {
    const sorted = prestations.filter(prestation => {
      return [
        statusPrestationsValues.cancelAvic,
        statusPrestationsValues.cancelInterprete,
        statusPrestationsValues.cancelClient,
        statusPrestationsValues.cancel,
      ].includes(prestation.status);
    });
    const key = "cancelled";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Annulées (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };
  const renderToutes = () => {
    const key = "total";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`Toutes (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  return (
    <>
      <Content>
        <Space
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography.Title level={2} className={""}>
            Prestations
          </Typography.Title>

          {user?.institution?.readOnlyPrestation === true ? null : (
            <UserCanDoActionMemo
              route={routes.prestations("new").new}
              action={"c"}
            >
              <a onClick={newPrestationLink}>
                <Button
                  size={"large"}
                  type={"primary"}
                  style={{
                    justifySelf: "flex-start",
                    display: "flex",
                  }}
                  icon={
                    <IoAddSharp
                      style={{
                        marginTop: "0px",
                      }}
                      size={25}
                    />
                  }
                >
                  Réserver un(e) interprète
                </Button>
              </a>
            </UserCanDoActionMemo>
          )}
        </Space>
        <CustomForm
          dataSource={inputsPrestationsList(
            defaultRanges,
            formRef,
            setSearchState,
            setPagination,
            dispatchActionPrestations,
            defaultPagination,
            loading,
            searcherObj?.searchState,
            advancedSearch,
            setAdvancedSearch,
          )}
          onKeyUp={handleKeyUp}
          labelCol={24}
          wrapperCol={24}
          resetOnFinish={undefined}
          refForm={formRef}
          onValuesChange={onValuesChange}
          handleSubmit={handleSubmit}
        />
        <Tabs
          onChange={onChangeTab}
          defaultActiveKey={tab}
          type={"card"}
          size={"large"}
          className={"prestations-tabs"}
        >
          {renderAccepter()}
          {renderAFinalise()}
          {renderWaiting()}
          {renderAVenir()}
          {renderToday()}
          {renderAVenir24h()}
          {renderTerminee()}
          {renderRetard()}
          {renderAnnule()}
          {renderToutes()}
        </Tabs>
      </Content>
    </>
  );
}
